module.exports = __webpack_public_path__ + "img/h3.1eda0485.jpg";